module.exports = "/*\n * Decathlon common library\n */\n\n//Primary anonymous wrapper to ensure that this section will be executed only once.\n(function() {\n\n\t// Global Configuration, completed in other \"common/*.js\"\n\tthis.Consts = {};\n\n\t// PolyFill custom 'log' methods (lightly used)\n\tthis.logError = function (message) {console.error(message)};\n\tthis.logWarning = function (message) {console.warn(message)};\n})();\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/legacy/common/common.legacy.js
// module id = 613
// module chunks = 31